import { render, staticRenderFns } from "./OrderFormModal.vue?vue&type=template&id=3011a888&scoped=true&"
import script from "./OrderFormModal.vue?vue&type=script&lang=js&"
export * from "./OrderFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3011a888",
  null
  
)

export default component.exports